module.exports = __webpack_public_path__ + "img/115.04b4ba01.jpg";